import React from 'react';
import './eventsHero.scss';

import IMAGE_1 from 'assets/events/events_header_1.png';
import IMAGE_2 from 'assets/events/events_header_2.png';
import IMAGE_3 from 'assets/events/events_header_3.png';
import {HeadingElement} from "../../../../components";

const EventsHero = () => {
    return (
        <div className={'events-hero'}>
            <div className="events-hero_top">
                <img className="events-hero_top_image_1" src={IMAGE_1} alt=""/>
                <img className="events-hero_top_image_3" src={IMAGE_3} alt=""/>
                <img className="events-hero_top_image_2" src={IMAGE_2} alt=""/>
            </div>
            <div className="events-hero_bottom max">
                <div className="events-hero_bottom_wrapper">
                    <HeadingElement/>
                    <h1>Business Events & Programs</h1>
                </div>
            </div>
        </div>
    );
};

export default EventsHero;
